const reports = {
  title: "Reports",
  pageSubtitle:
    "Create a report with the filters you need and download it from the list below.",
  loadingAccessibilityLabel: "Loading reports",
  exportsLoadingAccessibilityLabel: "Loading generated reports",
  emptyStateTitle: "No reports available",
  reportType: "Report type",
  newReport: "New report",
  generatedSectionTitle: "Generated reports",
  generatedReportsTableAriaLabel: "Generated reports",
  table: {
    dateGenerated: "Date generated",
    report: "Report",
    type: "Type",
    reportPeriod: "Report period",
    country: "Country",
    allCountries: "All countries",
    status: "Status",
    addedBy: "Added by",
    actions: "Actions",
  },
  directions: {
    all: "All",
  },
  status: {
    ready: "Ready",
    processing: "Processing",
    pending: "Pending",
    failed: "Failed",
  },
  exportFileTypes: {
    excel: "Excel",
    xlsx: "Excel",
    csv: "CSV",
    pdf: "PDF",
  },
  actions: {
    download: "Save",
    delete: "Delete",
  },
  generatedEmpty: {
    title: "No reports yet",
    description: "Generate your first report to see it here",
  },
  feedback: {
    createSuccess: "Report generation has been requested.",
  },
  deleteExportModal: {
    title: "Delete report",
    description: "Are you sure you want to delete this report?",
    warning: "This action cannot be undone.",
    cancel: "Cancel",
    confirm: "Delete",
  },
  createModal: {
    title: "Create report",
    datePlaceholder: "Select date",
    intro: "Choose parameters and file format. Your selections will be sent when generation is available.",
    sections: {
      parameters: "Parameters",
      format: "File format",
    },
    fields: {
      format: "Format",
    },
    paramLabels: {
      report_type: "Report type",
      reportType: "Report type",
      from_date: "From date",
      till_date: "Till date",
      to_date: "To date",
      start_date: "Start date",
      end_date: "End date",
      startDate: "Start date",
      endDate: "End date",
      file_type: "File type",
      fileType: "File type",
      country: "Country",
      country_code: "Country",
      countryCode: "Country",
      direction: "Direction",
      period: "Period",
      report_period: "Report period",
      format: "Format",
    },
    validation: {
      required: "Required",
      formatRequired: "Select a format",
    },
    actions: {
      cancel: "Cancel",
      create: "Create report",
    },
    noFormatHint: "No export formats are configured for this report yet.",
  },
};

export default reports;
